import CopyrightFooter from './CopyrightFooter/CopyrightFooter';
import MediaQueries from '../../shared/helpers/MediaQueries';
import MenuFooterMobile from './MenuFooterMobile/MenuFooterMobile';
import Seo from '../Seo/Seo';
import TrackingGoogleAnalytics from '../../Services/Tracking/TrackingGoogle/TrackingGoogleAnalytics';
import LoadEarlyBirdsChunk from '../../modules/InitChunks/LoadEarlyBirdsChunk/LoadEarlyBirdsChunk';
import ObfuscateLinks from './ObfuscateLinks/ObfuscateLinks';
import RedirectLangChunk from '../RedirectLang/RedirectLangChunk/RedirectLangChunk';
import LoadFlowboxChunk from '../../modules/InitChunks/LoadFlowboxChunk/LoadFlowboxChunk';

/**
 * Class Footer.
 */
export default class Footer {
  constructor() {
    // CopyrightFooter
    new CopyrightFooter();

    // Menus
    Footer.menusFooter();

    // Seo bottom
    Seo.seeMoreSeo('.c-seo__link');

    // Add tracking
    this.trackingFooter();

    // Add EarlyBirds
    new LoadEarlyBirdsChunk();

    // Add Flowbox
    new LoadFlowboxChunk();

    // Add Links obfuscate
    new ObfuscateLinks();

    // Add Old Redirect Lang
    new RedirectLangChunk();
  }

  /*
   * Add menus in page
   * */
  private static menusFooter() {
    // For Mobile & tablet & LG
    if (!MediaQueries.xl.matches) {
      // Menu Footer
      new MenuFooterMobile('.c-menuFooter__item');
    }
  }

  async trackingFooter() {
    // Add tracking GA
    const trackingGoogleAnalytics = new TrackingGoogleAnalytics();
    await trackingGoogleAnalytics.create();
  }
}
